module.exports = __webpack_public_path__ + "static/img/compro_help3.7f353cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compro_help3.png
// module id = BzYG
// module chunks = 1